import { Card } from '@synqo/frontend-component-library';
import { type FC } from 'react';
import { CustomizationGroup } from './CustomizationGroup';
import { type GroupedCustomizations } from './customizationGrouping';
import { CustomizationUpdater } from './props';

interface CustomizationsProps {
    groupedCustomizations: GroupedCustomizations;
    updateData: CustomizationUpdater;
    locked?: boolean;
}

export const Customizations: FC<CustomizationsProps> = ({ groupedCustomizations, updateData, locked }) => {
    return Object.entries(groupedCustomizations).map(([dataset, groups], index) => (
        <Card
            key={`dataset-${dataset}`}
            name="settings"
            collapsable={false}
            border={index === 0 ? 'withoutBorder' : 'withTopSeparator'}
        >
            {Object.entries(groups).map(([group, customizations]) => (
                <CustomizationGroup
                    key={`group-${group}`}
                    customizations={customizations}
                    locked={locked}
                    updateData={updateData}
                />
            ))}
        </Card>
    ));
};
